import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || '',
  environment: process.env.NODE_ENV || 'production',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Rastreia 100% das transacções em dev, 10% em produção
  tracesSampleRate: process.env.NODE_ENV === 'development' ? 1.0 : 0.1,
  // Grava 10% das sessões normais e 100% das sessões com erros
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: !!process.env.REACT_APP_SENTRY_DSN,
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App/>);